module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c2eb7ac401b3b0e25a6ac49405ae221e.png";